<template>
	<div class="container-end">
		<div class="info-container">
			<p class="info-select-question text-center text-info">Please select a question to review solution and explanations.</p>
		</div>
		<div class="menu-end-game">
			<div class="score-menu-end-game">
				<h5 class="title-score">Score</h5>
				<div class= "value-score">{{ score }}</div>
			</div>
			<div class="apreciation-end-game"> {{ apreciation }} </div>
			<div class="restart-end-game">
				<button class="btn-restart btn" @click="restartGame" type="button">Restart</button>
			</div>
		</div>
		<div class="good-answer">
			<div class="answer-quiz" v-if="index >= 0">{{ quiz.answerQuiz }}</div>
			<div v-else class="select-quiz-info">Select a quiz to display explained solution</div>
		</div>
		<div class="content-end-game">
			<h4 class="title-end-game">Summary of exercice</h4>
			<div class="summary-exercise">
				<div class="list-questions">
					<div v-for="(item, i) in treated" class="question-button">
						<button :class="['btn btn-outline-secondary', index == i ? 'active' : '']" @click="index = i">
							<i :class="['fa', item.found ? 'fa-check text-success' : 'fa-times text-danger']"></i>
							<span class="bt-text">Q {{ item.index }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="review">
			<transition name="slideDown" appear>
				<div class="review-question" v-if="index >= 0" :key="index">
					<h5 class="title-review-question">Review question: {{ treated[index].index }}</h5>
					<div class="problem-container">
						<div class="problem" :is="problemComponent"></div>
					</div>
					<div class="submited-answer">
						You submited <span class="submited-value" v-html="`<span>${treated[index].submited.toString()}</span`"></span>
						<template v-if="withReport">
							<report-buttons :edit-route="editRoute" :quiz="treated[index]" :report-quiz="reportQuiz" />
						</template>
					</div>
					<div class="correction-review">
						<explain-solution :quiz="treated[index].quiz"></explain-solution>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import ExplainSolution from './ExplainSolution.vue';
	import BaseExerciseMixin from '../js/BaseExerciseMixin';
	import FractionComponent from './FractionComponent';
	import ReportButtons from './ReportButtons';
	export default {
		mixins:[BaseExerciseMixin],
		props:{
			treated: {type: Array},
			apreciation: {type: String},
			restartGame: {type:Function},
			score: {type: Number},
			yourBestScore: { required: false, default: '' },
			generalBestScore: {required: false, default: '' },
			bestScoreName: { required: false, default: '' },
			editRoute: { default: null },
			withReport: { default: true },
			reportQuiz: { type: Function, default: null }
		},
		name: 'end-section',
		components: { ExplainSolution, FractionComponent, ReportButtons },
		data(){
			return {
				index: -1,
			}
		},
		created() {
		},
		computed: {
			problemComponent() {
				if (this.index < 0) {
					return {
						template: this.tag('div', 'Please select a question to review solution and explanations.', {class: 'text-center text-info'}),
						data() {
							return {}
						},
						name: 'ProblemEndSection',
						components: { FractionComponent }
					};
				}
				return {
					template: this.tag('div', this.treated[this.index].quiz.problem, {class: 'problem'}),
					data() {
						return {};
					},
					name: 'ProblemEndSection',
					components: { FractionComponent }
				}
			},
			quiz() {
				return this.treated[this.index];
			}
		},
		methods: {},
		watch: {
			quiz(to, from) {
				// console.log('quiz changed from:', from, 'to', to);
			}
		}
	};
</script>
<style lang="scss">
	.container-end {
		.info-container {
			.info-select {
				text-align: center;
			}
		}
		.content-end-game {
			.title-end-game {}
			.summary-exercise {
				.list-questions {
					.question-button {
						.btn {
							i {}
							.btn-text {}
							&.active {}
						}
					}
				}
			}
		}
		.menu-end-game {
			.score-menu-end-game {
				.title-score {}
				.value-score {}
			}
			.apreciation-end-game {}
			.restart-end-game {
				.btn-restart {}
			}
		}
		.good-answer {
			.answer-quiz {}
			.select-quiz-info {}
		}
		.review {
			.review-question {
				.title-review-question {}
				.problem-container {
					.problem {}
				}
				.submited-answer {
					.submited-value {}
				}
				.correction-review {}
			}
		}
	}
</style>
